import { MakeRoutesOpts } from "common/router/utils/routes";
import { MakePaths } from "common/router/types";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";

const paths = {
  paymentUpdate: "/care-plan-payment",
};

/** matches links CarePlanPaymentLinkRule */
type CarePlanPaymentSearch = {
  patient_care_ids: string;
};

type CarePlanPathDefinitions = {
  paymentUpdate: { Search: CarePlanPaymentSearch };
};

export type CarePlanPaths = MakePaths<CarePlanPathDefinitions>;

export const useCarePlanRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes(opts, [
    {
      path: paths.paymentUpdate,
      element: () => import("../components/CarePlanPaymentUpdatePage"),
      pageName: "care_plan_payment_update",
    },
  ]);
};

export const makeCarePlanUrls = (base: string) => {
  return makeUrls<CarePlanPathDefinitions>(base, {
    paymentUpdate: { path: paths.paymentUpdate },
  });
};
